import SpeedometerUpIcon from '@atlaskit/icon-lab/core/speedometer-up';
import * as React from 'react';

export function SvgSpeedMedium() {
  return <SpeedometerUpIcon label="" testId="ads-refreshed-icon" />;
}
